export const PLCC_BANNER_REQUEST = 'PLCC_BANNER_REQUEST';
export const PLCC_BANNER_SUCCESS = 'PLCC_BANNER_SUCCESS';
export const PLCC_BANNER_ERROR = 'PLCC_BANNER_ERROR';
export const CLEAR_PLCC_BANNER_DETAILS = 'CLEAR_PLCC_BANNER_DETAILS';
